export default __webpack_public_path__ + "static/media/11.1601d6bc.png";